<template>
    <div style="position: absolute; right: 0; bottom: 0" class="pa-2" v-show="$store.state.showSyncNotifications && notifications.length">

        <template v-for="(stat, i) in notifications">
            <sync-notification v-if="i >= notifications.length - 5" :key="i" :stat="stat" @remove="notifications.splice(i, 1)"></sync-notification>
        </template>

        <div class="d-flex align-center">

            <div class="flex-grow-1">
                <div class="caption pa-2 font-weight-black justify-end" v-if="notifications.length > 5">+{{notifications.length - 5}} More</div>
            </div>

            <v-tooltip left v-if="notifications.length">
                <template v-slot:activator="{on}">
                    <v-btn
                            icon
                            class="error white--text"
                            v-on="on"
                            @click="notifications.splice(0, notifications.length)"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
                Clear All
            </v-tooltip>
        </div>
    </div>
</template>

<script>

import {socketEvents} from "../../core/socket";
import SyncNotification from "./SyncNotification";

export default {
    components: {SyncNotification},
    props: {
        shown: Boolean
    },
    data() {
        return {
            notifications: []
        }
    },
    mounted() {
        socketEvents.on('syncStat', payload => this.notifications.push(payload))
    },
}
</script>

<style scoped>

</style>